import api from '@/api'

const { $pricing, $academic} = api;

export const { $prepaids, $types, $zones , $scholarships, $benefits } = $pricing;
export const { $terms, $careers  } = $academic;
